// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files-container {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  container-type: inline-size;
  container-name: files;
}

.sidebar {
  width: 140px;
  min-width: 140px;
  background: var(--surface-container);
  border-right: 1px solid var(--outline-variant);
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.sidebar::-webkit-scrollbar {
  width: 8px;
}
.sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}
.sidebar .shortcut {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  color: var(--on-surface);
  transition: background 0.15s;
}
.sidebar .shortcut:hover {
  background: var(--surface-container-high);
}
.sidebar .shortcut.active {
  background: var(--primary-container);
  color: var(--on-primary-container);
}
.sidebar .shortcut mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.sidebar .shortcut span {
  font-size: 13px;
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 6px 8px;
  padding: 5px 12px;
  font-size: 13px;
  overflow-x: auto;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: var(--surface-container);
  cursor: pointer;
  scrollbar-width: none;
}
.breadcrumb-bar::-webkit-scrollbar {
  display: none;
}
.breadcrumb-bar .segment {
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--on-surface-variant);
  transition: background 0.15s, color 0.15s;
}
.breadcrumb-bar .segment:hover {
  background: var(--surface-container-highest);
  color: var(--on-surface);
}
.breadcrumb-bar .segment:last-child {
  color: var(--on-surface);
  font-weight: 500;
}
.breadcrumb-bar .separator {
  color: var(--outline);
  opacity: 0.6;
}
.breadcrumb-bar.editing {
  border-color: var(--primary);
  gap: 6px;
  cursor: default;
}
.breadcrumb-bar.editing .path-edit-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--on-surface-variant);
  flex-shrink: 0;
}
.breadcrumb-bar.editing .path-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: var(--on-surface);
  min-width: 0;
}
.breadcrumb-bar.editing .path-input::placeholder {
  color: var(--on-surface-variant);
  opacity: 0.6;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--outline-variant);
  background: var(--surface-container-low);
}
.toolbar button {
  color: var(--on-surface-variant);
}
.toolbar .toolbar-spacer {
  flex: 1;
}
.toolbar .filter-input-wrapper {
  display: flex;
  align-items: center;
  background: var(--surface-container);
  border: 1px solid var(--outline-variant);
  border-radius: 4px;
  padding: 0 8px;
  height: 32px;
  flex: 1;
  min-width: 60px;
}
.toolbar .filter-input-wrapper .filter-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--on-surface-variant);
  margin-right: 4px;
}
.toolbar .filter-input-wrapper .filter-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: var(--on-surface);
  min-width: 0;
}
.toolbar .filter-input-wrapper .filter-input::placeholder {
  color: var(--on-surface-variant);
  opacity: 0.6;
}
.toolbar .filter-input-wrapper .filter-clear {
  font-size: 16px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: var(--on-surface-variant);
}
.toolbar .filter-input-wrapper .filter-clear:hover {
  color: var(--on-surface);
}
.toolbar .filter-input-wrapper:focus-within {
  border-color: var(--primary);
}

.loading, .error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  color: var(--on-surface-variant);
}
.loading mat-icon, .error mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 16px;
  gap: 16px;
  color: var(--on-surface-variant);
}
.empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}

.error {
  color: var(--error);
}
.error mat-icon {
  color: var(--error);
}

.file-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  margin-right: 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.file-list::-webkit-scrollbar {
  width: 8px;
}
.file-list::-webkit-scrollbar-track {
  background: transparent;
}
.file-list::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.file-list::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}
.file-list.grid-view {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 4px;
  align-content: start;
}
.file-list.list-view {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.file-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  text-align: center;
}
.file-item:hover {
  background: var(--surface-container-high);
}
.file-item.selected {
  background: var(--primary-container);
}
.file-item .file-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: var(--on-surface-variant);
}
.file-item .file-icon.folder-icon {
  color: var(--primary);
}
.file-item .file-name {
  font-size: 12px;
  color: var(--on-surface);
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 100%;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid var(--outline-variant);
}
.file-row:hover {
  background: var(--surface-container-high);
}
.file-row.selected {
  background: var(--primary-container);
}
.file-row .file-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--on-surface-variant);
}
.file-row .file-icon.folder-icon {
  color: var(--primary);
}
.file-row .file-name {
  flex: 1;
  font-size: 13px;
  color: var(--on-surface);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-row .file-size {
  font-size: 12px;
  color: var(--on-surface-variant);
  min-width: 60px;
  text-align: right;
}
.file-row .file-date {
  font-size: 12px;
  color: var(--on-surface-variant);
  min-width: 80px;
  text-align: right;
}

.toolbar-divider {
  width: 1px;
  height: 24px;
  background: var(--outline-variant);
  margin: 0 4px;
}

.delete-btn {
  color: var(--error) !important;
}

.files-container {
  position: relative;
}

.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--primary-rgb), 0.1);
  border: 2px dashed var(--primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 100;
  pointer-events: none;
}
.drag-overlay mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: var(--primary);
}
.drag-overlay span {
  font-size: 18px;
  color: var(--primary);
  font-weight: 500;
}

.upload-progress {
  position: absolute;
  bottom: 16px;
  right: 16px;
  background: var(--surface-container-high);
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 50;
  max-width: 300px;
}
.upload-progress .upload-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-size: 12px;
}
.upload-progress .upload-item mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.upload-progress .upload-item mat-icon.success {
  color: var(--tertiary);
}
.upload-progress .upload-item mat-icon.error {
  color: var(--error);
}
.upload-progress .upload-item .upload-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-progress .upload-item .upload-percent {
  color: var(--on-surface-variant);
}

.rename-input {
  background: var(--surface);
  border: 1px solid var(--primary);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 12px;
  color: var(--on-surface);
  width: 100%;
  max-width: 120px;
  outline: none;
}
.rename-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.2);
}

.empty-hint {
  font-size: 12px;
  color: var(--on-surface-variant);
  opacity: 0.7;
}

@container files (max-width: 700px) {
  :host ::ng-deep .filter-input-wrapper {
    display: none;
  }
  :host ::ng-deep .file-list {
    margin-right: 0;
  }
}
@container files (max-width: 600px) {
  :host ::ng-deep .sidebar {
    width: 55px;
    min-width: 55px;
    padding: 4px 0;
  }
  :host ::ng-deep .sidebar .shortcut {
    justify-content: center;
    padding: 8px;
    gap: 0;
  }
  :host ::ng-deep .sidebar .shortcut span {
    display: none;
  }
}
@container files (max-width: 500px) {
  :host ::ng-deep .file-list.grid-view {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
  :host ::ng-deep .file-row .file-size, :host ::ng-deep .file-row .file-date {
    display: none;
  }
  :host ::ng-deep .toolbar-divider {
    display: none;
  }
  :host ::ng-deep .file-list {
    padding: 4px;
  }
  :host ::ng-deep .toolbar {
    padding: 2px 4px;
    gap: 2px;
  }
}
@container files (max-width: 350px) {
  :host ::ng-deep .sidebar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/files-widget/files-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,8CAAA;EACA,cAAA;EACA,gBAAA;EAGA,qBAAA;EACA,qDAAA;AADF;AAGE;EACE,UAAA;AADJ;AAGE;EACE,uBAAA;AADJ;AAGE;EACE,oCAAA;EACA,kBAAA;AADJ;AAGI;EACE,oCAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,4BAAA;AAHJ;AAKI;EACE,yCAAA;AAHN;AAMI;EACE,oCAAA;EACA,kCAAA;AAJN;AAOI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AALN;AAQI;EACE,eAAA;AANN;;AAWA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AARF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EAGA,qBAAA;AAXF;AAYE;EAAuB,aAAA;AATzB;AAWE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,yCAAA;AATJ;AAWI;EACE,4CAAA;EACA,wBAAA;AATN;AAYI;EACE,wBAAA;EACA,gBAAA;AAVN;AAcE;EACE,qBAAA;EACA,YAAA;AAZJ;AAgBE;EACE,4BAAA;EACA,QAAA;EACA,eAAA;AAdJ;AAgBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;AAdN;AAiBI;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;AAfN;AAiBM;EACE,gCAAA;EACA,YAAA;AAfR;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,+CAAA;EACA,wCAAA;AAlBF;AAoBE;EACE,gCAAA;AAlBJ;AAqBE;EACE,OAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;AApBJ;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;AApBN;AAuBI;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;AArBN;AAuBM;EACE,gCAAA;EACA,YAAA;AArBR;AAyBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AAvBN;AAyBM;EACE,wBAAA;AAvBR;AA2BI;EACE,4BAAA;AAzBN;;AA8BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AA3BF;AA6BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;AA5BF;AA8BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA5BJ;;AAgCA;EACE,mBAAA;AA7BF;AA+BE;EACE,mBAAA;AA7BJ;;AAiCA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EAGA,qBAAA;EACA,qDAAA;AAhCF;AAkCE;EACE,UAAA;AAhCJ;AAkCE;EACE,uBAAA;AAhCJ;AAkCE;EACE,oCAAA;EACA,kBAAA;AAhCJ;AAkCI;EACE,oCAAA;AAhCN;AAoCE;EACE,aAAA;EACA,4DAAA;EACA,QAAA;EACA,oBAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAnCJ;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;AArCF;AAuCE;EACE,yCAAA;AArCJ;AAwCE;EACE,oCAAA;AAtCJ;AAyCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AAvCJ;AAyCI;EACE,qBAAA;AAvCN;AA2CE;EACE,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;AAzCJ;;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,+CAAA;AA3CF;AA6CE;EACE,yCAAA;AA3CJ;AA8CE;EACE,oCAAA;AA5CJ;AA+CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AA7CJ;AA+CI;EACE,qBAAA;AA7CN;AAiDE;EACE,OAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA/CJ;AAkDE;EACE,eAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AAhDJ;AAmDE;EACE,eAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AAjDJ;;AAsDA;EACE,UAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;AAnDF;;AAuDA;EACE,8BAAA;AApDF;;AAwDA;EACE,kBAAA;AArDF;;AAwDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;AArDF;AAuDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AArDJ;AAwDE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;AAtDJ;;AA2DA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AAxDF;AA0DE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AAxDJ;AA0DI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxDN;AA0DM;EACE,sBAAA;AAxDR;AA2DM;EACE,mBAAA;AAzDR;AA6DI;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3DN;AA8DI;EACE,gCAAA;AA5DN;;AAkEA;EACE,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AA/DF;AAiEE;EACE,4BAAA;EACA,mDAAA;AA/DJ;;AAoEA;EACE,eAAA;EACA,gCAAA;EACA,YAAA;AAjEF;;AA2EE;EACE;IACE,aAAA;EAxEJ;EA2EE;IACE,eAAA;EAzEJ;AACF;AA6EE;EACE;IACE,WAAA;IACA,eAAA;IACA,cAAA;EA3EJ;EA6EI;IACE,uBAAA;IACA,YAAA;IACA,MAAA;EA3EN;EA6EM;IACE,aAAA;EA3ER;AACF;AAgFE;EACE;IACE,4DAAA;EA9EJ;EAkFI;IACE,aAAA;EAhFN;EAoFE;IACE,aAAA;EAlFJ;EAqFE;IACE,YAAA;EAnFJ;EAsFE;IACE,gBAAA;IACA,QAAA;EApFJ;AACF;AAwFE;EACE;IACE,aAAA;EAtFJ;AACF","sourcesContent":[".files-container {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  container-type: inline-size;\n  container-name: files;\n}\n\n.sidebar {\n  width: 140px;\n  min-width: 140px;\n  background: var(--surface-container);\n  border-right: 1px solid var(--outline-variant);\n  padding: 8px 0;\n  overflow-y: auto;\n\n  // Themed scrollbar\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n\n  .shortcut {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    cursor: pointer;\n    color: var(--on-surface);\n    transition: background 0.15s;\n\n    &:hover {\n      background: var(--surface-container-high);\n    }\n\n    &.active {\n      background: var(--primary-container);\n      color: var(--on-primary-container);\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n\n    span {\n      font-size: 13px;\n    }\n  }\n}\n\n.main-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Breadcrumb bar — GNOME-inspired pill with border\n.breadcrumb-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 6px 8px;\n  padding: 5px 12px;\n  font-size: 13px;\n  overflow-x: auto;\n  white-space: nowrap;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  background: var(--surface-container);\n  cursor: pointer;\n\n  // Hide scrollbar\n  scrollbar-width: none;\n  &::-webkit-scrollbar { display: none; }\n\n  .segment {\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 4px;\n    color: var(--on-surface-variant);\n    transition: background 0.15s, color 0.15s;\n\n    &:hover {\n      background: var(--surface-container-highest);\n      color: var(--on-surface);\n    }\n\n    &:last-child {\n      color: var(--on-surface);\n      font-weight: 500;\n    }\n  }\n\n  .separator {\n    color: var(--outline);\n    opacity: 0.6;\n  }\n\n  // Editing mode: path text input replaces breadcrumb segments\n  &.editing {\n    border-color: var(--primary);\n    gap: 6px;\n    cursor: default;\n\n    .path-edit-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: var(--on-surface-variant);\n      flex-shrink: 0;\n    }\n\n    .path-input {\n      flex: 1;\n      border: none;\n      background: transparent;\n      outline: none;\n      font-size: 13px;\n      color: var(--on-surface);\n      min-width: 0;\n\n      &::placeholder {\n        color: var(--on-surface-variant);\n        opacity: 0.6;\n      }\n    }\n  }\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--outline-variant);\n  background: var(--surface-container-low);\n\n  button {\n    color: var(--on-surface-variant);\n  }\n\n  .toolbar-spacer {\n    flex: 1;\n  }\n\n  .filter-input-wrapper {\n    display: flex;\n    align-items: center;\n    background: var(--surface-container);\n    border: 1px solid var(--outline-variant);\n    border-radius: 4px;\n    padding: 0 8px;\n    height: 32px;\n    flex: 1;\n    min-width: 60px;\n\n    .filter-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: var(--on-surface-variant);\n      margin-right: 4px;\n    }\n\n    .filter-input {\n      flex: 1;\n      border: none;\n      background: transparent;\n      outline: none;\n      font-size: 13px;\n      color: var(--on-surface);\n      min-width: 0;\n\n      &::placeholder {\n        color: var(--on-surface-variant);\n        opacity: 0.6;\n      }\n    }\n\n    .filter-clear {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n      color: var(--on-surface-variant);\n\n      &:hover {\n        color: var(--on-surface);\n      }\n    }\n\n    &:focus-within {\n      border-color: var(--primary);\n    }\n  }\n}\n\n.loading, .error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n  color: var(--on-surface-variant);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    opacity: 0.5;\n  }\n}\n\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 48px 16px;\n  gap: 16px;\n  color: var(--on-surface-variant);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    opacity: 0.5;\n  }\n}\n\n.error {\n  color: var(--error);\n\n  mat-icon {\n    color: var(--error);\n  }\n}\n\n.file-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  margin-right: 16px; // Extra space so scrollbar doesn't overlap gridster resize handle\n\n  // Themed scrollbar\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n\n  &.grid-view {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 4px;\n    align-content: start;\n  }\n\n  &.list-view {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n}\n\n// Grid view file items\n.file-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n  text-align: center;\n\n  &:hover {\n    background: var(--surface-container-high);\n  }\n\n  &.selected {\n    background: var(--primary-container);\n  }\n\n  .file-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n    color: var(--on-surface-variant);\n\n    &.folder-icon {\n      color: var(--primary);\n    }\n  }\n\n  .file-name {\n    font-size: 12px;\n    color: var(--on-surface);\n    word-break: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    max-width: 100%;\n  }\n}\n\n// List view file rows\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  cursor: pointer;\n  transition: background 0.15s;\n  border-bottom: 1px solid var(--outline-variant);\n\n  &:hover {\n    background: var(--surface-container-high);\n  }\n\n  &.selected {\n    background: var(--primary-container);\n  }\n\n  .file-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: var(--on-surface-variant);\n\n    &.folder-icon {\n      color: var(--primary);\n    }\n  }\n\n  .file-name {\n    flex: 1;\n    font-size: 13px;\n    color: var(--on-surface);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .file-size {\n    font-size: 12px;\n    color: var(--on-surface-variant);\n    min-width: 60px;\n    text-align: right;\n  }\n\n  .file-date {\n    font-size: 12px;\n    color: var(--on-surface-variant);\n    min-width: 80px;\n    text-align: right;\n  }\n}\n\n// Toolbar divider\n.toolbar-divider {\n  width: 1px;\n  height: 24px;\n  background: var(--outline-variant);\n  margin: 0 4px;\n}\n\n// Delete button styling\n.delete-btn {\n  color: var(--error) !important;\n}\n\n// Drag and drop overlay\n.files-container {\n  position: relative;\n}\n\n.drag-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(var(--primary-rgb), 0.1);\n  border: 2px dashed var(--primary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  z-index: 100;\n  pointer-events: none;\n\n  mat-icon {\n    font-size: 64px;\n    width: 64px;\n    height: 64px;\n    color: var(--primary);\n  }\n\n  span {\n    font-size: 18px;\n    color: var(--primary);\n    font-weight: 500;\n  }\n}\n\n// Upload progress\n.upload-progress {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  background: var(--surface-container-high);\n  border-radius: 8px;\n  padding: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 50;\n  max-width: 300px;\n\n  .upload-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 8px;\n    font-size: 12px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n\n      &.success {\n        color: var(--tertiary);\n      }\n\n      &.error {\n        color: var(--error);\n      }\n    }\n\n    .upload-name {\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .upload-percent {\n      color: var(--on-surface-variant);\n    }\n  }\n}\n\n// Rename input\n.rename-input {\n  background: var(--surface);\n  border: 1px solid var(--primary);\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 12px;\n  color: var(--on-surface);\n  width: 100%;\n  max-width: 120px;\n  outline: none;\n\n  &:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.2);\n  }\n}\n\n// Empty folder hint\n.empty-hint {\n  font-size: 12px;\n  color: var(--on-surface-variant);\n  opacity: 0.7;\n}\n\n// Responsive: narrower widgets (container query responds to widget width, not viewport)\n// NOTE: ::ng-deep is required here because Angular's emulated view encapsulation\n// adds [_ngcontent-xxx] attribute selectors to rules inside @container blocks,\n// but some child elements don't receive the attribute when rendered via\n// *ngComponentOutlet (e.g. inside chat widget's app pane). ::ng-deep strips the\n// attribute selector so the rules match regardless.\n:host ::ng-deep {\n  @container files (max-width: 700px) {\n    .filter-input-wrapper {\n      display: none;\n    }\n\n    .file-list {\n      margin-right: 0;\n    }\n  }\n\n  // Slim sidebar: icon-only at narrow widths\n  @container files (max-width: 600px) {\n    .sidebar {\n      width: 55px;\n      min-width: 55px;\n      padding: 4px 0;\n\n      .shortcut {\n        justify-content: center;\n        padding: 8px;\n        gap: 0;\n\n        span {\n          display: none;\n        }\n      }\n    }\n  }\n\n  @container files (max-width: 500px) {\n    .file-list.grid-view {\n      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    }\n\n    .file-row {\n      .file-size, .file-date {\n        display: none;\n      }\n    }\n\n    .toolbar-divider {\n      display: none;\n    }\n\n    .file-list {\n      padding: 4px;\n    }\n\n    .toolbar {\n      padding: 2px 4px;\n      gap: 2px;\n    }\n  }\n\n  // Very narrow: hide sidebar entirely\n  @container files (max-width: 350px) {\n    .sidebar {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
